function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-109,345.4c-14.4,0-28-1.6-41.6-4.8c-12.8-3.2-25.6-7.2-38.4-12.8c11.2,8,20.8,16.8,30.4,27.2c8.8,9.6,16.8,20.8,24,32.8 c6.4,12,12,24,16.8,37.6c4.8,12.8,7.2,27.2,8.8,40.8c1.6-13.6,4-27.2,8.8-40.8c4-13.6,10.4-26.4,16.8-37.6c7.2-12,15.2-22.4,24-32.8 c9.6-10.4,19.2-19.2,30.4-27.2c-12,5.6-24.8,9.6-38.4,12.8C-81,343-94.6,344.6-109,345.4z"
});

var SvgSwrpgFailure = function SvgSwrpgFailure(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgFailure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-failure.0abe3207.svg";
export { ForwardRef as ReactComponent };